import { collisionGroup } from "../constants";

export const getDefaultCollisionMask = () => {
  return collisionGroup.all;
};
